import { __awaiter } from "tslib";
import Services from "../services";
import securityModule from "../security/SecurityModule";
const storage = window.sessionStorage ||
    new (class sessStorate {
        constructor() {
            this.cache = new Map();
            this.getItem = (key) => this.cache.get(key);
            this.setItem = (key, value) => this.cache.set(key, value);
            this.removeItem = (key) => this.cache.delete(key);
            this.clear = () => this.cache.clear();
            this.length = () => this.cache.size;
            this.key = (index) => {
                const keys = Array.from(this.cache.keys());
                return keys[index];
            };
        }
    })();
class TableUserStorageInstance {
    constructor(storageKey) {
        this.storageKey = storageKey;
        this.storeFilterText = (filterText) => {
            storage.setItem(`${this.storageKey}-filterText`, filterText);
        };
        this.retrieveFilterText = () => {
            const filterText = storage.getItem(`${this.storageKey}-filterText`);
            return filterText || "";
        };
        this.storeFilterTree = (filterTree, id, name, scope) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (id || name) {
                const newSF = yield Services.savedFilters.update({
                    id,
                    name,
                    scope,
                    filterDefinition: filterTree,
                    organizationId: securityModule.currentOrganizationId,
                });
                const newId = (_a = newSF.data) === null || _a === void 0 ? void 0 : _a.id;
                storage.setItem(`${this.storageKey}-filterTree`, JSON.stringify(filterTree));
                return newId || "";
            }
            else {
                storage.setItem(`${this.storageKey}-filterTree`, JSON.stringify(filterTree));
                return "";
            }
        });
        this.removeFilterTree = (id) => __awaiter(this, void 0, void 0, function* () {
            yield Services.savedFilters.delete(id);
        });
        this.retrieveFilterTree = (id) => {
            const filterTree = id
                ? storage.getItem(`${this.storageKey}-filterTree-${id}`)
                : storage.getItem(`${this.storageKey}-filterTree`);
            return filterTree ? JSON.parse(filterTree) : undefined;
        };
        this.fetchAllFilterTrees = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const savedFilters = yield Services.savedFilters.getAll(this.storageKey);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const filterGroups = ((_a = savedFilters.data) === null || _a === void 0 ? void 0 : _a.items) || [];
            storage.setItem(`${this.storageKey}-savedFilters`, JSON.stringify(filterGroups));
            return filterGroups;
        });
        this.storeSortFields = (sortFields) => {
            storage.setItem(`${this.storageKey}-sortFields`, JSON.stringify(sortFields));
        };
        this.retrieveSortFields = () => {
            const sortFields = storage.getItem(`${this.storageKey}-sortFields`);
            return sortFields
                ? JSON.parse(sortFields)
                : undefined;
        };
    }
}
export function createTableUserStorageInstance(storageKey) {
    return new TableUserStorageInstance(storageKey);
}
